export default __webpack_public_path__ + "687fe4f4f155e7bd1e8c94316e048087.png";